import { SupraSystemSubscriptionStatus } from '@bb/domain/dist/types';
import { getListingLockboxTypes } from 'api/ListingController';
import type { GetLockboxTypesForListingDTO } from 'api/ListingController/getListingLockboxTypes';
import { AuthContext } from 'contexts';
import { useState, useEffect, useContext } from 'react';

const DEFAULT_VALUE: GetLockboxTypesForListingDTO = {
  supra: false,
  masterLock: false,
  sentriLock: false,
  combinationLockbox: false,
};

const useListingLockboxTypes = (listingId?: string) => {
  const { auth } = useContext(AuthContext);

  const [map, setMap] = useState<Record<string, GetLockboxTypesForListingDTO>>(
    {},
  );

  const handleSupraOption = () => {
    const status = auth?.supraSubscription?.status;
    return status === SupraSystemSubscriptionStatus.subscribed;
  };

  const fetch = async () => {
    if (!listingId) return;

    const data = await getListingLockboxTypes(listingId);
    if (!data) return;

    data.supra = handleSupraOption();

    setMap(prev => ({
      ...prev,
      [listingId]: data,
    }));
  };

  useEffect(() => {
    if (!listingId) return;

    if (!map[listingId]) {
      fetch();
    }
  }, [listingId]);

  if (!listingId) return DEFAULT_VALUE;

  const value = map[listingId];

  return value ?? DEFAULT_VALUE;
};

export default useListingLockboxTypes;
